import React, { ReactNode } from 'react'
import KvitteringIllustrasjon from '../../assets/kvittering-illustrasjon.svg?react'
import styles from './styles.module.scss'

type KvitteringProps = {
  children: ReactNode
}

export default function Kvittering({ children }: KvitteringProps) {
  const columnClasses =`pkt-cell pkt-cell--span12 pkt-cell--span6-tablet-big-up p-size-30 ${styles.kvitteringColumn}`
  return (
    <>
      <div className={columnClasses}>
        <div className={'mt-size-30 mt-size-80--tablet-big-up pkt-txt-18-light'}>
          {children}
        </div>
      </div>
      <div className={columnClasses}>
        <div className={'pkt-hide-tablet-up'}>
          <KvitteringIllustrasjon height={270} width={270} />
        </div>
        <div className={'pkt-hide pkt-show-tablet-up mt-size-80--tablet-big-up'}>
          <KvitteringIllustrasjon />
        </div>
      </div>
    </>
  )
}
